<template>
  <div
    class="biChartWrap biDPieWrap"
    ref="biLineWrap">
    <svg
      ref="svg"
      v-if="data && data.length"
      :width="clientWidth"
      :height="clientHeight"
      :class="{'biChartBlur': refresh !== 0}">
      <bi-label
        :data="classes.data"
        :options="classes.options"
        @classesClick="classesClick"/>
      <g
        class="area"
        ref="area">
        <g
          class="gArea"
          v-for="(item, index) in data"
          :key="index"
          @mouseover="dataOver(index)"
          @mouseout="opacity(0)"/>
      </g>
      <g
        class="area1"
        ref="area1">
        <g
          class="gArea"
          @mouseover="childOver"
          @mouseout="opacity(0)"/>
      </g>
      <g
        class="titleList"
        ref="titleList"/>
      <text
        class="title"
        ref="title"/>
    </svg>
    <div
      class="center-p"
      v-show="refresh === 0 && !(classes.data.length) || refresh === 1 || refresh === 2 || refresh === 3">
      <el-tag type="warning"><i
        class="el-icon-loading"
        v-show="refresh === 1"/>{{ message[refresh] }}</el-tag>
      <el-button
        type="primary"
        size="mini"
        @click="reload"
        v-show="refresh === 0">
        <i class="el-icon-refresh"/>点击刷新
      </el-button>
    </div>
    <bi-tool-tip
      class="tooltip"
      :data="tooltip"/>
  </div>
</template>

<script>
import * as d3 from 'd3';
import Common from '@/components/charts/common';

export default {
  mixins: [Common],
  data() {
    return {
      bar: null,
      defaultOptions: {
        width: 0,
        height: 0,
        margin: {
          top: 50, right: 24, bottom: 20, left: 30
        },
        domainType: 'number',
        domainX: null,
        domainY: null,
        curve: '',
        innerRadiusPercent: 45,
        labelWidthPercent: 25,
        pieMargin: 5,
        titleHeight: 20,
        groupType: true
      },
      pie: {
        pieWidth: 0,
        pieHeight: 0,
        pieOR: 0,
        pieIR: 0,
        piePorintX: 0,
        piePorintY: 0
      },
      subTitle: '',
      pieData: {},
      ikey: 0
    };
  },
  props: {
    childData: {
      type: Array, default: () => []
    }
  },
  computed: {},
  methods: {
    xArea(x, i, w) {
      return x + (i * w);
    },
    createAllAttr() {
      d3.select(this.$refs.labelList).selectAll('*').remove();
      d3.select(this.$refs.area).selectAll('.gArea').selectAll('*').remove();
      d3.select(this.$refs.titleList).selectAll('*').remove();
      // 根据数据个数计算饼图范围
      let pieNum = this.data.length;
      if (this.childData.length) {
        pieNum++;
      }
      if (pieNum) {
        // 每一个饼的宽度
        let pieWidth = this.innerWidth / pieNum;
        // 每一个饼的高度
        let pieHeight = this.innerHeight - this.option.titleHeight;
        // 饼图外半径
        let pieOR = (d3.min([pieWidth, pieHeight]) / 2)
          - this.option.pieMargin;
        // 饼图内半径
        let pieIR = (pieOR * this.option.innerRadiusPercent) / 100;
        this.pie = {
          pieWidth,
          pieHeight,
          pieOR,
          pieIR,
          piePorintX: (pieWidth / 2) + this.left,
          piePorintY: (pieHeight / 2) + this.top
        };
      }
    },
    // 每一个rect是通过左上角坐标定位的
    initData() {
      if (this.option.classes && this.data.length !== 0) {
        this.createAllAttr();
      } else {
        // 输出一个无数据的效果
        return null;
      }
      let arc = d3.arc().innerRadius(this.pie.pieIR).outerRadius(this.pie.pieOR);
      let classes = this.classes.data;
      d3.select(this.$refs.area)
        .selectAll('.gArea')
        .each((d, i, t) => {
          let cur = d3.select(t[i]);
          let area = cur.selectAll('path');
          let titleList = d3.select(this.$refs.titleList).selectAll('path');
          if (this.data.length) {
            let x = this.xArea(this.pie.piePorintX, i, this.pie.pieWidth);
            let data = this.formatData(this.data[i].data, false, classes);
            if (data) {
              area.data(data).enter().append('path')
                .attr('fill', (d) => {
                  return this.getColor(d.class, classes);
                })
                .attr('transform', `translate(${x},${this.pie.piePorintY})`)
                .transition()
                .duration(1000)
                .attr('d', d => arc(d));
            }
            titleList.data(this.data).enter().append('text')
              .attr('x', (d, i) => {
                return ((this.pie.pieWidth / 2) + (i * this.pie.pieWidth)) + this.left;
              })
              .attr('y', this.bottom)
              .attr('class', 'center-t')
              .attr('style', 'text-anchor: middle;')
              .text(d => d.title);
          }
          if (this.childData.length) {
            // 添加点击事件
            cur
              .selectAll('path')
              .on('click', (d) => {
                let ikey = 0;
                for (let i = this.childData.length - 1; i >= 0; i--) {
                  if (this.childData[i].title === d.class) {
                    ikey = i;
                  }
                }
                this.ikey = ikey;
                this.childPie(this.childData[ikey]);
              });
            let ikey = 0;
            // 初始化第二图例
            this.childPie(this.childData[ikey]);
          }
        });
      this.onHover(this.$refs.area);
    },
    childPie(data) {
      d3.select(this.$refs.area1).select('.gArea').selectAll('*').remove();

      let arc = d3.arc().innerRadius(this.pie.pieIR).outerRadius(this.pie.pieOR);
      let area = d3.select(this.$refs.area1).select('.gArea').selectAll('path');
      // 开始画子饼
      let x = this.pie.piePorintX + this.pie.pieWidth;
      let classes = this.classes.data;
      let child = this.formatData(data.data, true, classes);
      if (child) {
        area.data(child).enter().append('path')
          .attr('fill', (d) => {
            return this.getColor(d.class, classes, true);
          })
          .attr('class', (d) => {
            return d.class;
          })
          .attr('transform', `translate(${x},${this.pie.piePorintY})`)
          .attr('d', (d) => {
            return arc(d);
          });
      }
      let title = typeof this.option.exTitle === 'string' ? data.title + this.option.exTitle : data.title;
      this.subTitle = title;
      d3.select(this.$refs.title)
        .attr('x', ((this.pie.pieWidth / 2) + this.pie.pieWidth) + this.left)
        .attr('y', this.bottom)
        .attr('class', 'center-t')
        .attr('style', 'text-anchor: middle;')
        .text(title);
      this.onHover(this.$refs.area1);
    },
    formatData(data, noCheck = false, classes = null) {
      let sum = 0;
      let dataStatus = false;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (noCheck || this.getLabelStatus(data[i].class, classes)) {
            sum += data[i].value;
          }
          data[i].color = this.getColor(data[i].class, classes, true);
        }
        data.sort((x, y) => {
          return y.value - x.value;
        });
        let pi = Math.PI * 2;
        let start = 0;
        for (let i = 0; i < data.length; i++) {
          if (noCheck || this.getLabelStatus(data[i].class, classes)) {
            data[i].startAngle = (pi * start) / sum;
            start += data[i].value;
            data[i].endAngle = (pi * start) / sum;
            dataStatus = true;
          } else {
            data[i].startAngle = (pi * start) / sum;
            data[i].endAngle = data[i].startAngle;
          }
        }
      }
      return dataStatus ? data : null;
    },
    opacity(opacity) {
      d3
        .select(this.$refs.biLineWrap)
        .select('.tooltip')
        .transition()
        .duration(this.duration / 2)
        .style('opacity', opacity || 0);
    },
    dataOver(index) {
      if (this.data.length === 0) return;
      let data = this.data[index];
      this.tooltip.title = data.title;
      let x = this.pie.piePorintX + this.pie.pieOR + this.option.pieMargin;
      this.tooltip.x = this.xArea(x, index, this.pie.pieWidth);
      this.tooltip.y = this.top;
      this.tooltip.desc = [];
      data.data.forEach((d) => {
        let label = this.getLabel(d.class, this.classes.data);
        if (label.status) {
          label.value = d.value;
          this.tooltip.desc.push(label);
        }
      });
      this.opacity(1);
    },
    childOver() {
      this.tooltip.title = this.subTitle;
      let x = this.pie.piePorintX + this.pie.pieOR + this.option.pieMargin;
      this.tooltip.x = this.xArea(x, 1, this.pie.pieWidth);
      this.tooltip.y = this.top;
      this.tooltip.desc = [];
      this.childData[this.ikey].data.forEach((d) => {
        let label = this.getLabel(d.class, this.classes.data);
        if (label.status) {
          label.value = d.value;
          this.tooltip.desc.push(label);
        }
      });
      this.opacity(1);
    },
    classesClick(ix) {
      this.classes.data = this.changeClassStatus(ix, this.classes.data);
      this.initData();
    },
    onHover(area) {
      if (area) {
        d3
          .select(area)
          .selectAll('.gArea')
          .on('mouseover', (d, i, t) => {
            let arc = d3.arc().innerRadius(this.pie.pieIR).outerRadius(this.pie.pieOR + 10);
            d3.select(t[i]).selectAll('path')
              .transition()
              .duration(this.duration)
              .attr('d', (d) => {
                return arc(d);
              })
              .ease(d3.easeElastic);
          })
          .on('mouseout', (d, i, t) => {
            let arc = d3.arc().innerRadius(this.pie.pieIR).outerRadius(this.pie.pieOR);
            d3.select(t[i]).selectAll('path')
              .transition()
              .duration(this.duration)
              .attr('d', (d) => {
                return arc(d);
              })
              .ease(d3.easeElastic);
          });
      }
    }
  },
  watch: {
    data() {
      this.$nextTick(() => {
        if (this.option.classes) {
          this.classes.data = this.option.classes.map((d, i) => {
            return {
              title: d,
              color: this.colors[i],
              type: 'pie',
              status: true,
              view: true
            };
          });
          this.classes.options = {
            panelWidth: this.clientWidth,
            labelWidthPercent: this.option.labelWidthPercent
          };
          if (this.option.classes1) {
            let classes1 = this.option.classes1;
            for (let i = classes1.length - 1; i >= 0; i--) {
              let index = (i + this.option.classes.length) % this.colors.length;
              this.classes.data.push({
                title: classes1[i],
                color: this.colors[index],
                type: 'pie',
                status: true,
                view: false
              });
            }
          }
        }
        this.initData();
      });
    }
  }
};
</script>

<style>
.biDPieWrap {
  position: relative;
  height: 100%;
}

.biChartBlur {
  opacity: .25;
  filter: blur(12px);
}

.biDPieWrap svg {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.biDPieWrap line {
  shape-rendering: crispEdges;
}

.biDPieWrap .axis path,
.biDPieWrap .axis line {
  fill: none;
  stroke: black;
  shape-rendering: crispEdges;
}

.biDPieWrap .focus circle {
  fill: none;
  stroke: none;
  pointer-events: auto;
}

.biDPieWrap .center-p {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.biDPieWrap .center-p button {
  margin-top: 20px;
}

</style>
